export const CAROUSEL_TARGET_OPTIONS = [
	{ value: "workshop", label: "کارگاه" },
	{ value: "webinar", label: "وبینار" },
	{ value: "video_clip", label: "چالش (کلیپ)" },
	{ value: "doctor", label: "پروفایل درمانگر" },
	{ value: "url", label: "لینک خارجی" },
];

export function carouselItemEntityId(form) {
	if (!form) return "";
	switch (form.target_type) {
		case "workshop":
			return form.workshop || "";
		case "webinar":
			return form.webinar || "";
		case "video_clip":
			return form.video_clip || "";
		case "doctor":
			return form.doctor || "";
		default:
			return "";
	}
}

export function seedEntityOptionsFromItem(item) {
	if (!item?.target_type) return [];
	const id =
		item.workshop ||
		item.webinar ||
		item.video_clip ||
		item.doctor;
	if (!id) return [];
	const title =
		item.workshop_title ||
		item.webinar_title ||
		item.video_clip_title ||
		item.doctor_name ||
		`#${id}`;
	return [{ id, title, name: item.doctor_name }];
}

export function heroSlideSummary(slide) {
	if (!slide) return "";
	switch (slide.target_type) {
		case "workshop":
			return slide.workshop_title || `کارگاه #${slide.workshop}`;
		case "webinar":
			return slide.webinar_title || `وبینار #${slide.webinar}`;
		case "video_clip":
			return slide.video_clip_title || `چالش #${slide.video_clip}`;
		case "url":
			return slide.url || "لینک";
		default:
			return slide.doctor_name || "درمانگر";
	}
}

export function carouselItemSummary(item) {
	if (!item) return "";
	switch (item.target_type) {
		case "workshop":
			return item.workshop_title || `کارگاه #${item.workshop}`;
		case "webinar":
			return item.webinar_title || `وبینار #${item.webinar}`;
		case "video_clip":
			return item.video_clip_title || `چالش #${item.video_clip}`;
		case "url":
			return item.url || "لینک";
		default:
			return item.doctor_name || "درمانگر";
	}
}
